import { Stack } from "@mui/material"
import { FC } from "react"
import Chart from 'react-apexcharts'
import { ChartSeries, useProcessChart } from "../../../presenter/useProcessChart";
import { ChartDescItem } from "../../../../general/ui/components/chartDescItem";

interface IProps {
    chartSeries: ChartSeries;
    labels: string[];
};

export const ChartBody: FC<IProps> = ({ chartSeries, labels }) => {
    const chartOptions = useProcessChart(labels);

    return (
        <Stack direction="row" alignItems="center">
            <Chart height={200} options={chartOptions} series={chartSeries} type="donut" />
            <Stack spacing={2} flex={1} pr={2}>
                {chartSeries.map((item, index) => (
                    <ChartDescItem
                        key={index}
                        item={item}
                        label={labels[index]}
                        color={chartOptions.colors![index]}
                    />
                ))}
            </Stack>
        </Stack>
    )
}